import { useCallback, useEffect, useState } from "react";
import { ISelectOptions } from "../../../types/inputs";
import { LocalAtendimentoEnum } from "../../../enums/localAtendimento";
import { Delivery } from "../../../services/Delivery";

import { IAgendamentoAlterarTipoFormRHF } from "../../../types/agendamento";
import { useForm, Controller } from "react-hook-form";
import { Cliente } from "../../../services/Cliente";
import { toast } from "react-toastify";
import { useContextSite } from "../../../context/Context";
import { ViaCep } from "../../../services/ViaCep";
import { maskCep, maskPhone } from "../../../utils/masks";
import { Ibge } from "../../../services/Ibge";

export const useFormDeliveryRescheduling = () => {
  const [cidadesOptions, setCidadesOptions] = useState<ISelectOptions[]>(
    [] as ISelectOptions[]
  );
  const [cidadesformOptions, setCidadesFormOptions] = useState<
    ISelectOptions[]
  >([] as ISelectOptions[]);
  const [ufOptions, setUfOptions] = useState<ISelectOptions[]>([]);
  const [concessionarias, setConcessionarias] = useState<ISelectOptions[]>([]);
  const localOptions = Object.entries(LocalAtendimentoEnum).map((item) => ({
    value: item[0],
    label: item[1],
  }));
  const { setIsLoad } = useContextSite();
  const getCidades = useCallback(() => {
    Delivery.get().then(({ data }) => {
      const options = data.content.map((item) => ({
        label: item.cidade,
        value: item.uuid,
        element: item,
      }));

      setCidadesOptions(options);
    });
  }, []);
  const { control, handleSubmit, watch, resetField, register, setValue } =
    useForm<IAgendamentoAlterarTipoFormRHF>({
      defaultValues: {
        concessionaria: "",
        nome: "",
        telefone: "",
        uuid: "",
        uuidConcessionaria: "",
        uuidDelivery: "",
        endereco: {
          bairro: "",
          cep: "",
          cidade: "",
          complemento: "",
          logradouro: "",
          numero: "",
          uf: "",
        },
      },
    });

  useEffect(() => {
    getCidades();
  }, []);

  useEffect(() => {
    if (watch("uuidDelivery")) {
      resetField("uuidConcessionaria");
      Cliente.getConcessionarias({
        cidade: cidadesOptions.find((e) => e.value === watch("uuidDelivery"))
          ?.label,
      })
        .then(({ data }) => {
          const options = data.content.map((item) => ({
            value: item.uuid,
            label: item.nome,
            element: item,
          }));

          setConcessionarias(options);
        })
        .catch(
          ({
            response: {
              data: { mensagem },
            },
          }) => toast.error(mensagem)
        );
    }
  }, [watch("uuidDelivery")]);

  function handleCep() {
    if (watch("endereco.cep").length === 9) {
      setIsLoad(true);
      setTimeout(() => {
        ViaCep.get(watch("endereco.cep"))
          .then(({ data }) => {
            setValue("endereco.logradouro", data.logradouro);
            setValue("endereco.bairro", data.bairro);
            setValue("endereco.cidade", data.localidade);
            setValue("endereco.uf", data.uf);
          })
          .catch((erro) => toast.error("Cep não encontrado"))
          .finally(() => setIsLoad(false));
      }, 1000);
    }
  }

  useEffect(() => {
    if (watch("endereco.uf")) {
      Ibge.CidadesPorEstado({ sigla: watch("endereco.uf") })
        .then(({ data }) => {
          const options = data.map((item) => ({
            value: item.nome,
            label: item.nome,
            element: item,
          }));
          setCidadesFormOptions(options);
        })
        .catch((erro) => toast.error("Erro ao requisitar as cidades"));
    }
  }, [watch("endereco.uf")]);

  useEffect(() => {
    Ibge.UFs()
      .then(({ data }) => {
        const options = data.map((item) => ({
          value: item.sigla,
          label: item.sigla,
          element: item,
        }));

        setUfOptions(options);
      })
      .catch((erro) => toast.error("Erro ao requisitar as UFs"));
  }, []);

  useEffect(() => {
    if (watch("endereco.cep")?.length) {
      const newCep = maskCep(watch("endereco.cep"));
      setValue("endereco.cep", newCep);
    }
  }, [watch("endereco.cep")]);

  useEffect(() => {
    const newPhoneValue = maskPhone(watch("telefone"));
    setValue("telefone", newPhoneValue);
  }, [watch("telefone")]);

  useEffect(() => {
    resetField("nome");
    resetField("telefone");
    resetField("endereco.cep");
    resetField("endereco.logradouro");
    resetField("endereco.numero");
    resetField("endereco.complemento");
    resetField("endereco.bairro");
    resetField("endereco.uf");
    resetField("uuidConcessionaria");
    resetField("endereco.cidade");
  }, [watch("concessionaria")]);

  return {
    cidadesOptions,
    localOptions,
    Controller,
    control,
    handleSubmit,
    watch,
    concessionarias,
    register,
    handleCep,
    ufOptions,
    cidadesformOptions,
  };
};
